import BaseComponent from '../../../core/infraestructure/BaseComponent'

export default {
    extends: BaseComponent,
    data() {
        return {
            
        };
    },
    props: {
        fileUrl: {
            type: String,
            required: true,
        },
        bindContextMenu: {
            type: Function,
            required: true,
        }
    },
    created() {},
    mounted() {},
    methods: {
        onBindFileContextMenu() {
           this.bindContextMenu()
        }
    }
};
